import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import Header from '@/components/feature/Header';
import { movies, featuredIds } from '@/mocks/movies';
import HeroCarousel from './components/HeroCarousel';
import CategoryEntries from './components/CategoryEntries';
import LatestUpdates from './components/LatestUpdates';
import HotRecommend from './components/HotRecommend';
import PlatformIntro from './components/PlatformIntro';

export default function Home() {
  const featured = featuredIds
    .map((id) => movies.find((item) => item.id === id))
    .filter((item): item is NonNullable<typeof item> => Boolean(item));

  const latest = [...movies].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt)).slice(0, 6);

  return (
    <SiteLayout
      title="丝瓜视频-热门影视剧视频资源平台"
      description="丝瓜视频提供丰富的电影、电视剧和综艺节目资源，满足用户多样化的视频观看需求，内容更新及时，体验流畅。"
      keywords="丝瓜视频,影视视频,电影电视剧,视频在线,视频分享平台,热门剧集"
    >
      <div className="relative">
        <div className="absolute inset-x-0 top-0 z-50">
          <Header />
        </div>
        <HeroCarousel items={featured} />
      </div>
      <main className="flex-1 pb-4">
        <CategoryEntries />
        <LatestUpdates movies={latest} />
        <HotRecommend />
        <PlatformIntro />

        <section className="w-full px-4 md:px-8 mt-14 md:mt-20">
          <div className="relative rounded-lg overflow-hidden bg-foreground-950">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20background%20with%20warm%20amber%20light%20rays%20and%20soft%20dust%20particles%20over%20a%20dark%20textured%20surface%2C%20minimal%20artistic%20composition%2C%20elegant%20atmosphere&width=1600&height=600&seq=sigua-cta-band&orientation=landscape"
              alt="丝瓜视频片单入口"
              className="absolute inset-0 w-full h-full object-cover object-top opacity-60"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/20"></div>
            <div className="relative px-6 md:px-12 py-10 md:py-14 flex flex-col md:flex-row md:items-center gap-6 md:gap-10">
              <div className="flex-1">
                <h2 className="font-heading text-2xl md:text-3xl font-black text-white leading-snug">
                  建一个只属于你的片单
                </h2>
                <p className="mt-2 text-sm text-white/75 max-w-xl leading-relaxed">
                  在任意详情页点击收藏，作品会保存在你的浏览器中。随时回到「我的收藏」，继续未完成的清单。
                </p>
              </div>
              <div className="flex flex-wrap items-center gap-3">
                <Link
                  to="/favorites"
                  className="px-6 h-11 inline-flex items-center gap-2 rounded-md bg-primary-500 text-background-50 text-sm font-bold hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  <i className="ri-bookmark-3-line"></i>
                  查看我的收藏
                </Link>
                <Link
                  to="/search"
                  className="px-6 h-11 inline-flex items-center gap-2 rounded-md bg-white/10 border border-white/30 text-white text-sm font-medium hover:bg-white/20 transition-colors whitespace-nowrap"
                >
                  <i className="ri-search-line"></i>
                  搜索影视
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
    </SiteLayout>
  );
}